import React from 'react';
import './PollEditor.css';

// 發文時的投票編輯器（受控元件）。value 結構：{ enabled, question, poll_type, options:[] }。
// 僅在頻道已開啟「允許發投票文」時，由發文頁掛載本元件。
const PollEditor = ({ value, onChange }) => {
  const poll = value || { enabled: false, question: '', poll_type: 'SINGLE', options: ['', ''] };

  const update = (patch) => onChange({ ...poll, ...patch });
  const setOption = (idx, text) => {
    const options = [...poll.options];
    options[idx] = text;
    update({ options });
  };
  const addOption = () => update({ options: [...poll.options, ''] });
  const removeOption = (idx) => {
    if (poll.options.length <= 2) return; // 至少保留兩個選項
    update({ options: poll.options.filter((_, i) => i !== idx) });
  };

  return (
    <div className="poll-editor">
      <label className="poll-editor-toggle">
        <input type="checkbox" checked={poll.enabled} onChange={(e) => update({ enabled: e.target.checked })} />
        <span>加入投票</span>
      </label>

      {poll.enabled && (
        <div className="poll-editor-body">
          <input
            className="form-control poll-editor-question"
            placeholder="投票題目，例如：下個 sprint 先做哪一項？"
            value={poll.question}
            onChange={(e) => update({ question: e.target.value })}
          />
          <div className="poll-editor-type">
            <label><input type="radio" checked={poll.poll_type === 'SINGLE'} onChange={() => update({ poll_type: 'SINGLE' })} /> 單選</label>
            <label><input type="radio" checked={poll.poll_type === 'MULTIPLE'} onChange={() => update({ poll_type: 'MULTIPLE' })} /> 複選</label>
          </div>
          <div className="poll-editor-options">
            {poll.options.map((opt, idx) => (
              <div key={idx} className="poll-editor-option">
                <input
                  className="form-control"
                  placeholder={`選項 ${idx + 1}`}
                  value={opt}
                  onChange={(e) => setOption(idx, e.target.value)}
                />
                {poll.options.length > 2 && (
                  <button type="button" className="poll-editor-remove" onClick={() => removeOption(idx)} aria-label="移除選項">✕</button>
                )}
              </div>
            ))}
          </div>
          <button type="button" className="btn btn-sm poll-editor-add" onClick={addOption}>＋ 新增選項</button>
        </div>
      )}
    </div>
  );
};

export default PollEditor;
